import React from "react";
import CalloutSection from "../../UI/CalloutSection/CalloutSection";
import image from "../../../assets/images/identity-princeton.jpg";
import classes from './PrincetonReview.module.css'

const StudyAbroad = (props) => (
  <CalloutSection image={image} alt="This is the alt tag!">
    <div className={classes.Content}> 
      <h2>Dickinson is #11 on the Princeton Review's list of Best Schools for Making an Impact.</h2>
    </div>
  </CalloutSection>
);
export default StudyAbroad;
